import type {FC} from 'react';
import LazyLoading from '@/components/common/LazyLoading';
import ForestMassList from '@/components/ForestMassList';
import {useController} from './controller';

const ForestMassListView: FC = () => {
  const {
    forestMassesStatuses,
    loading,
    userPermissions,
    onAdd,
    onSelectForestMass,
    sortModel,
    onSortModelChange,
    filterModel,
    onFilterModelChange,
  } = useController();

  if (loading) {
    return <LazyLoading />;
  }

  return (
    <ForestMassList
      forestMassesStatuses={forestMassesStatuses}
      permissions={userPermissions}
      onAdd={onAdd}
      onForestMassClick={onSelectForestMass}
      sortModel={sortModel}
      onSortModelChange={onSortModelChange}
      filterModel={filterModel}
      onFilterModelChange={onFilterModelChange}
    />
  );
};

export default ForestMassListView;
